import { withFormik } from "formik";
import * as Yup from "yup";
import { isValidPhoneNumber } from "react-phone-number-input";

const formikEnhancer = withFormik({
  mapPropsToValues: () => ({
    name: "",
    email: "",
    password: "",
    passwordCheck: "",
    phone: "",
    areas_of_expertise: "",
    exampleCheck1: false
  }),

  validationSchema: Yup.object().shape({
    name: Yup.string()
      .min(3, "O nome deve ter pelo menos 3 caracteres.")
      .required("O nome completo é obrigatório."),
    email: Yup.string()
      .email("Digite um e-mail válido")
      .required("Este campo é obrigatório"),

    phone: Yup.string()
      .required("O telefone é obrigatório.")
      .test("is-valid-phone", "Número de telefone inválido.", value =>
        value ? isValidPhoneNumber(value) : false
      ),

    areas_of_expertise: Yup.string().required("Selecione uma área de atuação."),

    password: Yup.string().required("Este campo é obrigatório"),
    passwordCheck: Yup.string()
      .required("Este campo é obrigatório")
      .oneOf([Yup.ref("password"), null], "As senhas devem coincidir"),
    exampleCheck1: Yup.bool().oneOf([true], "Você deve concordar com os T&C")
  }),

  handleSubmit: values => {
  },
  displayName: "CustomValidationForm",
  enableReinitialize: true
});

export default formikEnhancer;
